import React, { ReactElement } from 'react';

import { FormattedMessage } from 'react-intl';

import { ModalLayout } from 'components/b2c/ModalLayout';

import { IconContainer, Title, Description } from './Modal.style';

export interface ModalProps {
  isOpen: boolean;
  onClose?: (event: React.MouseEvent<Element, MouseEvent>) => void;
  titleId: string;
  titleValues?: Record<string, string | ReactElement>;
  descriptionId?: string;
  descriptionValues?: Record<string, string>;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const Modal: React.FunctionComponent<ModalProps> = ({
  isOpen,
  onClose,
  titleId,
  titleValues,
  descriptionId,
  icon,
  children,
  descriptionValues,
}) => {
  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      {icon && <IconContainer>{icon}</IconContainer>}
      <Title>
        <FormattedMessage id={titleId} values={titleValues} />
      </Title>
      {descriptionId && (
        <Description>
          <FormattedMessage id={descriptionId} values={descriptionValues} />
        </Description>
      )}
      {children}
    </ModalLayout>
  );
};

export default Modal;
